module.exports = __webpack_public_path__ + "2e4fc41fe69b3ade29a7718034b3bf85.svg";